import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";
import DebitCreditList from "../../components/DebitCredit/List/DebitCreditList";
import { withRouter } from "react-router";

const DebitCreditListPage = (props) => {
  return (
    <Wrapper>
      {props.isBread ? (
        <BreadcrumbsTemp
          items={[
            {
              title: "لیست معاملات ماشین",
              to: "/debit-credit/list",
            },
          ]}
        />
      ) : null}

      <Grid container={true}>
        <Grid item xs={12}>
          <DebitCreditList
            name={props.match.params.name}
            user={props.user_id}
            isPerson={props.isPerson}
            pdfName={props.pdfName ? props.pdfName : ""}
          />
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default withRouter(DebitCreditListPage);
